import { render, staticRenderFns } from "./StatementRegister.vue?vue&type=template&id=6cf63520&scoped=true"
import script from "./StatementRegister.vue?vue&type=script&lang=js"
export * from "./StatementRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf63520",
  null
  
)

export default component.exports